import { User } from "../../../types/User";
import EmployerAnalyticsDossierSummaries from "../components/EmployerAnalyticsDossierSummaries";

const EmployerViewAnalyticsPayrollTaxSavingsSummaries = ({
  me,
}: {
  me: User;
}) => {
  return (
    <EmployerAnalyticsDossierSummaries
      me={me}
      title="Annualised Payroll Tax Savings"
      subtitle="This is a breakdown of all active leases and estimated annualised payroll tax savings per employee."
      amountField="annualisedPayrollTaxSaving"
      amountHeader="Annualised Payroll Tax Savings"
      sortBy="annualisedPayrollTaxSaving"
    />
  );
};

export default EmployerViewAnalyticsPayrollTaxSavingsSummaries;
